var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"subtitle is-5"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.loading}}),_vm._v(" "),(!_vm.loading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }